import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DOCUMENT_GET_ATTACHMENT_TYPES, DOCUMENT_MODULE_NAMESPACE } from '../../../../store/document';

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class TicketModalUploadButtonNew extends Vue {


  @DocumentStore.Action(DOCUMENT_GET_ATTACHMENT_TYPES)
  storeGetAttachmentTypes: (id?: number) => Promise<any>


  private _clearTimeout: any;
  dtDocumentConfigs: { minimum: number, image: { alpha: number }, video: { alpha: number }, document: { alpha: number } }
  dtButonHeight: number | null
  dtUploadButtons: {
    type: string;
    icon: string;
    translationKey: string;
    acceptedType: string;
  }[];
  dtFileError: boolean;
  dtError: any;
  chooseFileDialog:boolean
  files:any[]
  type:number
  typeLvl2:number
  dtTypesLevel1?: any[]
  dtTypesLevel2?: any[]
  isLoading:boolean
  dtAttributesLvl1?: any[]
  dtAttributesLvl2?: any[]
  fkFileAttr: {
    fk_attribute: number,
    value: number | string | boolean
  }[]
  reference:string
  valid:boolean

  get lblSetting() {
    return {
      ...require('../../../../locales/generic-labels').default,
      ...require('@/locales/document').default,
    }
  }

  @Prop({ default: () => [], type: [Object, Array] })
  value: any;

  @Prop({ default: null, type: [Array] })
  buttons: { type: string; icon: string; translationKey: string; acceptedType: string; }[];
  @Prop({ default: null, type: [Object], required: false })
  creator: Object | null


  @Prop({ default: '', type: [String], required: false })
  customClass: string

  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;

  @Watch('coAttributes')
  handleAttributesChange (value: any[]) {
    console.log('Attributes = ',value)
    if(value.length)
    {
      this.fkFileAttr = value.map(item=>{
        return {
          fk_attribute:item.id,
          value:null
        }
      })
    } else {
      this.fkFileAttr = []
    }
  }
  /**
   *
   */
  constructor() {
    super();
    this.dtDocumentConfigs = require('../../../../configs/ticket-document-maxsize.config.json');
    this.dtButonHeight = 76.5;
    this.dtError = null;
    this.dtFileError = false;
    this.chooseFileDialog = false;
    this.files = []
    this.type = null
    this.typeLvl2 = null
    this.dtTypesLevel2 = []
    this.dtTypesLevel1 = []
    this.isLoading = false
    this.dtAttributesLvl1 = []
    this.dtAttributesLvl2 = []
    this.fkFileAttr = []
    this.reference = null
    this.valid = true
  }

  get coButtons() {
    if (this.buttons) {
      return this.buttons;
    }
    return [
      { type: 'image', icon: 'icon-photo', translationKey: this.lblSetting.lblPhoto, acceptedType: 'image/*' },
      { type: 'file', icon: 'icon-video', translationKey: this.lblSetting.lblVideo, acceptedType: 'video/*' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblDocument, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' }
    ]
  }
  get vModel(): any[] { return this.value; }
  set vModel(value: any[]) { this.$emit('input', value); }


  get coTypes1() {
    return this.dtTypesLevel1 || []
  }

  get coTypes2() {
    return this.dtTypesLevel2 || []
  }

  get coAttributes() {
    return this.dtAttributesLvl1.concat(this.dtAttributesLvl2)
  }


  mounted()
  {
    this.handleGetTypesLevel1()
  }


  /* fillFileAttr () {
    this.fkFileAttr = (this.value || []).map(item => {
      return (this.coAttributes || []).map(attribute => {
        if (item.attributes.find(x => x.fk_attribute === attribute.id)) {
          return item.attributes.find(x => x.fk_attribute === attribute.id)
        } else {
          return this.attributeParam(attribute, null)
        }
      })
    })
  }

  attributeParam (attribute, value = null) {
    let attr = {
      fk_attribute: attribute.id,
      value: value
    }
    if (value === null && attribute.attribute_type.type === 'boolean') attr.value = false
    return attr
  } */

  handleGetTypesLevel1() {
    //this.isLoading = true
    this.storeGetAttachmentTypes()
      .then(res => {
        this.dtTypesLevel1 = res
        /* if(this.$route.params.id && this.$route.name === 'document_attachment')
        {
          let preSelectedDocType = res.find(dt => dt.id === parseInt(this.$route.params.id))
          this.type = preSelectedDocType.id
          this.handleGetTypesLevel2()
        } */
      }).finally(()=>{
        //this.isLoading = false
      })
  }


  handleGetTypesLevel2() {
    if (!this.type) return []
    else if (this.mediaTypeLevel2Allowed || this.mediaAttributeAllowed) {
      this.isLoading = true
      this.storeGetAttachmentTypes(this.type)
        .then(res => {
          this.dtTypesLevel2 = res.level_2.filter(level2 => level2.enabled === true)//this.isUpdateAction ? res.level_2 : res.level_2.filter(level2 => level2.enabled === true)
          if (res.level_2.length && this.mediaTypeLevel2Allowed) {
            if (!this.typeLvl2 || !res.level_2.find(x => x.id === this.typeLvl2))
            {
              this.typeLvl2 = res.level_2[0].id
            }
            this.handleGetAttributesLevel2()
          }
          //if (res.attributes.length && this.$route.meta['media_attribute_allowed']) {
          if (this.mediaAttributeAllowed) {
            this.dtAttributesLvl1 = res.attributes
          }
        }).finally(()=>{
          this.isLoading = false
        })
    }
  }

  handleGetAttributesLevel2() {
    if (!this.typeLvl2) return
    else if (this.mediaAttributeAllowed) {
      this.storeGetAttachmentTypes(this.typeLvl2)
        .then(res => {
          console.log(res)
          this.dtAttributesLvl2 = res.attributes
        })
    }
  }

  get mediaAttributeAllowed () {
    if (!localStorage.getItem('document_management')) return false
    return JSON.parse(localStorage.getItem('document_management')).media_attribute_allowed || false
  }

  get mediaTypeLevel2Allowed () {
    if (!localStorage.getItem('document_management')) return false
    return JSON.parse(localStorage.getItem('document_management')).media_type_level2_allowed || false
  }

  handleUpload() {
    console.log('handleUpload');
    (this.$refs.inputFile as HTMLElement).click()
    //(this.$refs['inputFile'][0] as any).click();
  }
  handleRecordFileToUpload()
  {
    console.log('handleRecordFileToUpload')
    this.files[0].reference = this.reference
    this.files[0].attributes = this.fkFileAttr
    this.files[0].fk_attachment_type = this.type
    this.files[0].fk_attachment_type_level_2 = this.typeLvl2
    console.log(this.files[0])
    this.vModel.push(this.files[0])
    this.handleCancelSelect()
  }
  getButtonStyle(refName: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {
      if (this.$refs[refName][0]) {
        const ele = this.$refs[refName][0].$el;
        this.dtButonHeight = (ele.clientWidth - (ele.clientWidth * 8) / 100);
      }
    }, 10);
    return {
      height: `calc(${this.dtButonHeight}px)`
    };
  }

  handleCancelSelect()
  {
    //console.log(this.$refs.inputFile);
    (this.$refs.inputFile as any).value = null
    this.valid = true
    this.files = []
    this.reference = null
    this.fkFileAttr = []
    this.type = null
    this.typeLvl2 = null
    this.chooseFileDialog = false
  }

  humanReadableFileSize(size) {
      const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let i = 0;
      while(size >= 1024) {
          size /= 1024;
          ++i;
      }
      return Math.round(size.toFixed(2)) + ' ' + units[i];
  }

  getFileType(file) {
    var fileType = file.type.split('/')[0];
    if (fileType === "image") {
      return "image";
    } else if (fileType === "video") {
      return "video";
    } else if (fileType === "application") {
      return "document";
    } else {
      return "unknown";
    }
  }

  //icon-quote
  getFileIcon(file) {
    var fileType = file.type.split('/')[0];
    if (fileType === "image") {
      return "icon-photo";
    } else if (fileType === "video") {
      return "icon-video";
    } else if (fileType === "application") {
      return "icon-quote";
    } else {
      return "icon-quote";
    }
  }


  async handleSelectFiles({ files }) {
    console.log('handleSelectFiles',this.fkFileAttr)
    this.files = []
    if (files.length === 0) return;
    for (let fIndex: number = 0; fIndex < files.length; fIndex++) {
      await this.getBase64URL(files[fIndex]).then((fileReader: FileReader)=>{
        const file = files[fIndex];
        console.log('********',file)
        const newFile = {...file}
        newFile.name = file.name
        newFile.icon = this.getFileIcon(file)
        newFile.size = this.humanReadableFileSize(file.size)
        newFile.customType = this.getFileType(file)
        newFile.id = `${file.lastModified}-${this.vModel.length}`;
        fileReader.onloadend = () => {
          newFile.url = fileReader.result;
        }
        newFile.percentage = 0;
        newFile.fakeId = `${new Date().getTime()}-${file.size}-${fIndex}`;
        newFile.loader_id = `${new Date().getTime()}-${file.size}-${fIndex}`;
        if (this.creator) {
          newFile.creator = this.creator;
        }
        return Promise.resolve(newFile)
      }).then(file => {
        setTimeout(() => {
          this.files.push(file)
          this.chooseFileDialog = true
          console.log(this.files)
        }, 100);
      }).catch(error => console.log(error)).finally(()=>{
        (this.$refs.inputFile as any).value = null
      })
    }

    /* for (let fIndex: number = 0; fIndex < files.length; fIndex++) {
      await this.getBase64URL(files[fIndex])
        .then((fileReader: FileReader) => {

          const file = files[fIndex];
          file.id = `${file.lastModified}-${this.vModel.length}`;
          file.customType = 'type';
          file.icon = 'icon';
          fileReader.onloadend = () => {
            file.url = fileReader.result;
          }
          file.percentage = 0;
          file.fakeId = `${new Date().getTime()}-${file.size}-${fIndex}`;
          file.loader_id = `${new Date().getTime()}-${file.size}-${fIndex}`;
          if (this.creator) {
            file.creator = this.creator;
          }
          return Promise.resolve(file)
        })
        .then(file => {
          //setTimeout(() => this.vModel.push(file), 100);
          setTimeout(() => {
            this.files.push(file)
            this.chooseFileDialog = true
            console.log(this.files)
          }, 100);
        })
        .then(() => this.handleResetForm(type, index))
        .catch(error => console.log(error))
    } */

  }

  async handleAddFile()
  {
    /* type files = {
      attributes?:any[]
      file?:string
      fk_attachment_type?:number|null
      fk_attachment_type_level_2?:number|null
      name?:string
      reference?:string
      type?:string
    }
    const newFile:{
      creator?:number
      loader_id?:number
      files?:files[]
    } = {}

    const tempFile = this.files[0]

    if(tempFile.creator) { newFile.creator = tempFile.creator.id}
    newFile.loader_id = tempFile.loader_id
    newFile.files = this.files
    this.vModel.push(newFile) */

  }

  /* async handleAddFile({ files }, type: string, icon: string, index: number) {
    if (files.length === 0) return;

    for (let fIndex: number = 0; fIndex < files.length; fIndex++) {
      await this.getBase64URL(files[fIndex])
        .then((fileReader: FileReader) => {

          const file = files[fIndex];
          file.id = `${file.lastModified}-${this.vModel.length}`;
          file.customType = type;
          file.icon = icon;
          fileReader.onloadend = () => {
            file.url = fileReader.result;
          }
          file.percentage = 0;
          file.fakeId = `${new Date().getTime()}-${file.size}-${fIndex}`;
          file.loader_id = `${new Date().getTime()}-${file.size}-${fIndex}`;
          if (this.creator) {
            file.creator = this.creator;
          }
          return Promise.resolve(file)
        })
        .then(file => {
          setTimeout(() => this.vModel.push(file), 100);
        })
        .then(() => this.handleResetForm(type, index))
        .catch(error => console.log(error))
    }
  } */


  async handleRemoveFile(file: any, index: number, type: string) {
    this.vModel = this.vModel.filter(item => item.id !== file.id);
  }

  handleResetForm(type: string, index: number) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      const form = this.$refs[`form-${type}-${index}`] as any;
      if (form) {
        form[0].reset();
        form[0].value = null
      }
    }, 100)
  }
  private async getBase64URL(file): Promise<FileReader> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    return Promise.resolve(fileReader);
  }
  private calculateMaxSize(type): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }
  private validateFileSize(size: number, type: string) {
    return size < this.calculateMaxSize(type);
  }

  handleHideError() {
    this.dtError = null;
    this.dtFileError = false;
  }
}

export default TicketModalUploadButtonNew;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-upload-buttons-new/index.ts